import styled from 'styled-components';

export const ModalMLStyled = styled.div`
  .footBotton {
    color: red;
    width: 20vw;
  }
  .ant-modal-content {
    background: red;
    border: 1px solid red;
    .ant-btn-primary {
      background-color: ${(props) => props.theme[props.brand].modal.bgColor};
      border-color: ${(props) => props.theme[props.brand].modal.bgColor};
    }
  }
`;
